import { Component, ViewChild, inject } from '@angular/core';
import { RmdCalc } from '../../models/rmd-models';
import { FormGroup, NgForm, FormsModule } from '@angular/forms';
import { RmdService } from '../rmd.service';
import { MaskService } from '../../services/mask.service';
import Highcharts from 'highcharts';
import { SessionStorageService } from '../../services/session-storage.service';

import { MaskitoDirective } from '@maskito/angular';
import { CurrencyPipe } from '@angular/common';
import { NgxLoadingModule } from 'ngx-loading';
import { UtilityToolbarComponent } from '../../shared-components/utility-toolbar/utility-toolbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { HighchartsChartComponent } from 'highcharts-angular';

@Component({
  selector: 'app-rmd-calculation',
  templateUrl: './rmd-calculation.component.html',
  styleUrls: ['./rmd-calculation.component.scss'],
  imports: [
    FormsModule,
    MaskitoDirective,
    CurrencyPipe,
    NgxLoadingModule,
    UtilityToolbarComponent,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    KENDO_GRID,
    HighchartsChartComponent,
  ],
})
export class RmdCalculationComponent {
  private rmds = inject(RmdService);
  private mask = inject(MaskService);
  private ss = inject(SessionStorageService);

  @ViewChild('rmdForm', { static: false }) rmdForm: NgForm;

  form: FormGroup;
  formData: RmdCalc = {
    AgeAtIssue: 55,
    AgeAtFirstWithdrawal: 65,
    AgeAtFirstCashWithdrawal: 65,
    MortalityAge: 92,
    LifetimeIncome: null,
    AnnualIncomeNeed: 0,
    IncomeRisingRate: 0,
    EquityHoldings: null,
    FixedIncome: null,
    Annuity: null,
    IncomeAnnuity: null,
    EquityHoldingsRate: 6,
    FixedIncomeRate: 3.5,
    AnnuityRate: 2,
    IncomeAnnuityRate: 2,
    InflationRate: 2,
  };
  Highcharts: typeof Highcharts = Highcharts;
  dollarMask = this.mask.dollarMaskSpecs();
  percentMask = this.mask.percentMaskSpecs();
  calcComplete = false;
  calcData = {};
  chartData = [];
  tableData = [];
  loading = false;
  tableHeaderValue: number;
  tableColumns = [];

  calculate(data) {
    this.loading = true;
    const percRegex = new RegExp(/%/),
      moneyRegex = new RegExp(/^\$/);

    const submittedData = {};

    Object.keys(data).forEach(x => {
      if (
        percRegex.test(data[x]) ||
        x === 'InflationRate' ||
        x === 'AnnuityRate' ||
        x === 'FixedIncomeRate' ||
        x === 'EquityHoldingsRate' ||
        x === 'IncomeAnnuityRate' ||
        x === 'IncomeRisingRate'
      ) {
        submittedData[`RMDCalcInput.${x}`] = this.mask.removePercentMask(
          data[x]
        );
      } else if (moneyRegex.test(data[x])) {
        submittedData[`RMDCalcInput.${x}`] = this.mask.removeMoneyMask(data[x]);
      } else {
        submittedData[`RMDCalcInput.${x}`] = data[x];
      }
    });

    this.rmds.getRmdCalc(submittedData).subscribe(x => {
      this.calcComplete = true;
      this.calcData = x;
      this.chartData = [];
      x['charts'].forEach(chrt => {
        const data = chrt.Data;
        this.chartData.push(data);
      });

      this.tableHeaderValue = x.RMDCalc.ValueAtDeath;

      this.tableData = x.RMDCalcArray;
      this.tableColumns = x.RMDHeader;
      this.loading = false;
    });
  }

  editCalc() {
    this.calcComplete = false;
  }

  resetCalc() {
    this.chartData = [];
    this.calcData = {};
    this.tableData = [];
    this.tableColumns = [];
    this.tableHeaderValue = null;
    this.loading = false;
    this.calcComplete = false;
    Object.keys(this.formData).forEach(x => (this.formData[x] = null));
  }
}
